import messages from "../../lib/libraries/tag-messages.js"
export default [
    {tag: 'pot', intlLabel: 'PotentiaMod', color: '#4900D1'},
    {tag: 'dm', intlLabel: 'DinosaurMod', color: '#80f41a'},
    {tag: 'pm', intlLabel: 'PenguinMod', color: '#00c3ff'},
    {tag: 'amp', intlLabel: 'AmpMod', color: '#4FA55C'},
    {tag: 'mistium', intlLabel: 'Mistium', color: '#D399E5'},
    {tag: 'ae', intlLabel: 'Astra Editor', color: '#0099FF'},
    {tag: 'ob', intlLabel: 'OmniBlocks', color: '#59C0C0'},
    {tag: 'rw', intlLabel: 'RemixWarp', color: '#000000'},
    {tag: 'ztengine', intlLabel: '02Engine', color: '#00BAAD'},
    {tag: 'other', intlLabel: 'Other Mods', color: '#ad4e00'},
    {tag: 'theme', intlLabel: 'Theme', color: '#9ad4cf'},
    {tag: 'recommended', intlLabel: 'Recommended', color: '#175ef8'},
    {tag: 'beta', intlLabel: 'Beta', color: '#fd662b'},
    {tag: 'new', intlLabel: 'New', color: '#b117f8'},
    {tag: 'danger', intlLabel: 'Danger', color: '#fd2b2b'}
];